module.exports = __webpack_public_path__ + "static/media/6.7235a54f.jpg";